import { Skeleton } from '@aimsos/ui';

/**
 * Placeholder rows for a loading entity list.
 *
 * Rendered inside the SAME `gap-3` stack as the loaded rows so the swap does
 * not shift the page. The count is capped at the reference's
 * `Math.max(1, Math.min(perPage, 6))`: a full page of skeletons on a 50-row
 * page size is a wall of grey, and nobody reads past the first few.
 */
function EntityListSkeleton({ perPage = 10 }) {
  const count = Math.max(1, Math.min(perPage, 6));

  return (
    <div className="flex flex-col gap-3">
      {Array.from({ length: count }, (_, idx) => (
        <div
          key={idx}
          data-testid="entity-row-skeleton"
          className="rounded-xl border border-edge bg-surface/40 p-4"
        >
          <div className="flex items-start gap-3">
            <Skeleton width="32px" height="32px" borderRadius="8px" />
            <div className="flex min-w-0 flex-1 flex-col gap-2">
              <Skeleton width="45%" height="14px" borderRadius="4px" />
              <Skeleton width="80%" height="12px" borderRadius="4px" />
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}

export default EntityListSkeleton;
